<div class="col-md-12 d-flex justify-content-center mb-3 headers-headings mobile-header-div">
  <a class="mobile-header" onclick="history.back()">
    <span class="icon">
      <img src="../../../../assets/images/factsheet/backIcon.svg" alt="">
    </span>
    {{tournamentname}} </a>
</div>
<div *ngIf="!userAccess && !showPage" class="not-found-section">
  <div class="col-md-12 not-found-body">
    <img src="assets/img/logo/not-found.gif" alt="">
    <h1>Oops! This page doesn't exist.</h1>
    <p>The link you followed may be broken or the page has been removed.</p>

  </div>
</div>
<div class="actionsBtn mobileActionBtn">
  <ul>
    <li>
      <a href="{{shareurl}}" target="_blank">
        <button class="shareBtn">
          <div class="icon">
            <img src="../../../../assets/images/factsheet/share-08.svg" alt="">
          </div>
          <div class="title">
            SHARE
          </div>
        </button>
      </a>

    </li>
    <li>
      <button class="registerBtn">
        <div class="icon">
          <img src="../../../../assets/images/factsheet/register.svg" alt="">
        </div>
        <div class="title" [disabled]="(outdate_reg_status || !showRegisterButton)" *ngIf="!tournamentIds.includes(tournamentId)" id="edit-login"
          (click)="(showRegisterButton) ? showloginDialog(tournamentId) : ''">
          Register
        </div>
        <div class="title" [disabled]="(outdate_reg_status || !showRegisterButton)" *ngIf="tournamentIds.includes(tournamentId)"
          id="edit-login" (click)="(showRegisterButton) ? withdrawtournament(tournamentId,lastdateofwithdraw) : ''">
          Edit Registration
        </div>
      </button>
    </li>
  </ul>
</div>
<section class="team Tournaments-list tournament-list-main">
  <div class=" container aos-init aos-animate" data-aos="fade-up">
    <div class="row">
      <div class="col-md-12 mainPageTitle">
        <div class="pageTitle">
          <h2>{{tournamentname}}</h2>
        </div>
        <div class="tab-div">
          <div *ngIf="userAccess && showPage" class="mainTabsDiv">
            <ul class="tabList">
              <li>
                <button routerLink="/tournaments/factsheet/{{tournamentId}}" [routerLinkActive]="'active-btn'">
                  Info
                </button>

                <!-- 
                <a class="nav-link active" aria-current="page"
                 >INFO
                </a> -->
              </li>
              <li>
                <button  (click)="onDrawClick('bottom')">
                  Draws
                </button>
                <!-- <button *ngIf="ownlink" routerLink="/tournament-draw/{{tournamentId}}"
                  [routerLinkActive]="'active-btn'">
                  Draws
                </button>
                <button *ngIf="!ownlink" routerLink="/tournament-draw-view/{{tournamentId}}"
                  [routerLinkActive]="'active-btn'">
                  Draws
                </button> -->
              </li>
              <li>
                <button   [routerLinkActive]="'active-btn'" (click)="onDrawClick('bottom')">
                  Results
                </button>
                <!-- <button routerLink="/result/{{tournamentId}}" [routerLinkActive]="'active-btn'">
                  Results
                </button> -->
              </li>

            </ul>
          </div>

          <!-- <ul class="tabList">
              <li>
                <button (click)="activeTab = 2" [ngClass]="{'active-btn': activeTab === 2}">
                  Upcoming
                </button>
              </li>
              <li>
                <button (click)="activeTab = 1" [ngClass]="{'active-btn': activeTab === 1}">
                  Live
                </button>
              </li>
              <li>
                <button (click)="activeTab = 0" [ngClass]="{'active-btn': activeTab === 0}">
                  Completed
                </button>
              </li>
            </ul> -->
        </div>
      </div>
      <div class="factsheetBody">
        <div class="mainDetials">
          <div class="tournament-div-details">
            <div class="tournament-header">
              <div class="tournament-logo-div">
                <div class="logoTitle">
                  <div class="logoImg">
                    <img [src]="(academyPic) ? academyPic : '../../../../assets/images/academy_dummy.jpg'" alt=""
                      class="mainLogo">
                  </div>
                  <div class="logoTitledetails">
                    <div class="titleTop">
                      <div class="date">
                        <span>
                          {{ startdate | date:'dd/MM/YY' }} - {{ enddate | date:'dd/MM/YY' }}
                        </span>
                      </div>
                    </div>
                    <div class="tournamentName">
                      <h5>{{tournamentname}}</h5>
                    </div>
                  </div>
                </div>

                <!-- <img src="../../../assets/images/home-page/logotournamet.png" alt=""> -->

              </div>
            </div>

            <!-- <div class="touranmentLocation">
                                <div class="location">
                                  <div class="icon">
                                    <img src="../../../assets/images/home-page/locationfilled.svg" alt="">
                                  </div>
                                  <div class="city">
                                    <span>{{tournaments.cityname}}</span>
                                  </div>
                                </div>
                              </div> -->


            <div class="tournament-table">
              <table>
                <tr>
                  <td class="left-table">
                    <div class="lable">
                      <div class="left-icon">
                        <img src="../../../../assets/images/factsheet/user.svg" alt="">
                      </div>
                      <div class="title">
                        Hosted By
                      </div>
                    </div>
                  </td>
                  <td class="right-table">
                    <span class="name">
                      {{academyName}}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="left-table">
                    <div class="lable">
                      <div class="left-icon">
                        <img src="../../../../assets/images/factsheet/level.svg" alt="">
                      </div>
                      <div class="title">
                        Level
                      </div>
                    </div>
                  </td>
                  <td class="right-table">
                    {{item?.pointsDataName}}
                  </td>
                </tr>

                <tr>
                  <td class="left-table">
                    <div class="lable">
                      <div class="left-icon">
                        <img src="../../../../assets/images/factsheet/draw.svg" alt="">
                      </div>
                      <div class="title">
                        Draw Type
                      </div>
                    </div>
                  </td>
                  <td class="right-table">
                    {{ drawType }}
                  </td>
                </tr>
              </table>
              <table>
                <tr>
                  <td class="left-table">
                    <div class="lable">
                      <div class="left-icon">
                        <img src="../../../../assets/images/factsheet/users.svg" alt="">
                      </div>
                      <div class="title">
                        Registered Players
                      </div>
                    </div>

                  </td>
                  <td class="right-table OrganizerDiv">
                    <p class="mobileNumber Click" (click)="onClicktournamentPlayerList()" *ngIf="showplayerList">
                      {{totalPlayercount}} PLAYERS
                    </p>
                    <p class="mobileNumber noneClick" *ngIf="!showplayerList">
                      {{totalPlayercount}} PLAYERS
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="left-table">
                    <div class="lable">
                      <div class="left-icon">
                        <img src="../../../../assets/images/factsheet/date.svg" alt="">
                      </div>
                      <div class="title">
                        Last Date of Registration
                      </div>
                    </div>
                  </td>
                  <td class="right-table">
                    <!-- {{ lastdateofregistration | date:'dd/MM/yyyy':'UTC' }} -->
                      {{ lastdateofregistration | date:'dd/MM/yyyy hh:mm a':'UTC' }}
                  </td>
                </tr>

                <tr>
                  <td class="left-table">
                    <div class="lable">
                      <div class="left-icon">
                        <img src="../../../assets/images/home-page/category.svg" alt="">
                      </div>
                      <div class="title">
                        Last Date of Withdrawal
                      </div>
                    </div>
                  </td>
                  <td class="right-table">
                      {{ lastdateofwithdraw | date:'dd/MM/yyyy hh:mm a':'UTC' }}
                    <!-- {{ lastdateofwithdraw | date:'dd/MM/yyyy':'UTC' }} -->
                    <!-- <span class="CategoriesListdiv">
 
                                                        {{(!tournaments.isViewMore) ? tournaments.matchDataName[0] : tournaments.matchDataName }}
                                                    </span>
                                                    <button class="viewMoreBtn" (click)="viewMoreCategoriesToggleOption(tournaments)">{{ (!tournaments.isViewMore) ? 'VIEW MORE' : 'VIEW LESS'}}</button> -->
                  </td>
                </tr>

            <tr *ngIf="prizePool">
              <td class="left-table">
                <div class="lable">
                  <div class="left-icon">
                    <img src="../../../../assets/images/factsheet/date.svg" alt="">
                  </div>
                  <div class="title">
                    Prize Pool
                  </div>
                </div>
              </td>
            
              <td class="right-table">
                ₹ {{ prizePool }}
              </td>
            </tr>
              </table>
            </div>
          </div>
          <div class="sponserDiv" *ngIf="item?.sponsor_logo.length > 0">
            <div class="sponserTitle">
              <h4>sponsors</h4>
            </div>
            <div class="sponserList" *ngIf="item?.sponsor_logo.length > 0">
              <ul>
                <li  *ngFor="let sponsor of item?.sponsor_logo">
                  <img [src]="sponsor?.img_src" alt="Image not Available">
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="actionsBtn">
          <ul>
            <li>
              <a href="{{shareurl}}" target="_blank">
                <button class="shareBtn">
                  <div class="icon">
                    <img src="../../../../assets/images/factsheet/share-08.svg" alt="">
                  </div>
                  <div class="title">
                    SHARE
                  </div>
                </button>
              </a>

            </li>
            <li *ngIf="showRegisterButton">
              <button class="registerBtn" [disabled]="tournamentIds.includes(tournamentId) ? outdate_withdraw_status : outdate_reg_status">
            
                <div class="icon">
                  <img src="../../../../assets/images/factsheet/register.svg" alt="">
                </div>
            
                <div class="title" *ngIf="!tournamentIds.includes(tournamentId)" id="edit-login"
                  (click)="showloginDialog(tournamentId)">
                  Register
                </div>
            
                <div class="title" *ngIf="tournamentIds.includes(tournamentId)" id="edit-login"
                  (click)="withdrawtournament(tournamentId,lastdateofwithdraw)">
                  Edit Registration
                </div>
            
              </button>
            </li>
          </ul>
        </div>
        <div class="locationDiv">
          <div class="locationheader">
            <div class="icon">
              <img src="../../../../assets/images/factsheet/location.svg" alt="">
            </div>
            <div class="title">
              <h4>Location</h4>
            </div>
          </div>
          <div class="locationBody">
            <p>
              {{address}}, {{cityname}}, {{statename}} {{zipcode}}, {{countryname}}
            </p>
            <!-- <p>AITA Courts , Gate No. 2 , Mumbai University , Kalina , Santacruz East , Mumbai, Mumbai Suburban,
              Maharashtra 400098, India</p> -->
            <a [href]="googleMapLink" *ngIf="googleMapLink" target="_blank">
              <button>
                <div class="title">
                  OPEN MAP
                </div>
                <div class="icon">
                  <img src="../../../../assets/images/factsheet/go.svg" alt="">
                </div>
              </button>
            </a>
          </div>
        </div>
        <div class="OrganizerDiv">
          <div class="Organizerheader">
            <div class="icon">
              <img src="../../../../assets/images/factsheet/user-star-02.svg" alt="">
            </div>
            <div class="title">
              <h4>Organizer</h4>
              <div class="OrganizerBody">
                <p class="name"> {{organizerName}}</p>
                <p class="mobileNumber">
                  +{{ organizerPhoneCode }} {{ organizercontactnumber}}
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="full-divider"></div>
  <div class=" bottomContainer container aos-init aos-animate" data-aos="fade-up">
    <div class="row">
      <div class="col-md-12">
        <h3 class="factSheettitle">Categories</h3>
      </div>
      <div class="col-md-12 categoryTable">
        <table>
          <thead>
            <tr>
              <th class="leftTd">
                <p><span class="icon"> <img src="../../../../assets/images/factsheet/c1.svg" alt=""> </span> category
                </p>
              </th>
              <th class="centerTd">
                <p><span class="icon"> <img src="../../../../assets/images/factsheet/c2.svg" alt=""> </span> Entry fee
                </p>
              </th>
              <th class="rightTd">
                <p><span class="icon"> <img src="../../../../assets/images/factsheet/c3.svg" alt=""> </span> draw size
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tournamentCategory of tournamentCategories">
              <td>{{ tournamentCategory?.category }}</td>
              <td class="text-center">₹{{ tournamentCategory?.entryFee }}</td>
              <td class="text-right">{{ tournamentCategory?.drawSize }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12 rules-regulationDiv">
        <h3 class="factSheettitle">Tournament rules and regulations</h3>
        <p class="titleText">{{tournamentname}}</p>
        <div class="rulesList">
          <div class="rulesHeader">
            <h5>tournament format:</h5>
          </div>
          <div class="rulesBody">
            <div class="formateDetails">
              <h4 *ngIf="rulesTitle">{{ rulesTitle }}</h4>
              <p *ngIf="rulesDescription" [innerText]="rulesDescription"></p>
            </div>
            <div class="registrationDetails">
              <h4 *ngIf="rulesTitleTwo">{{rulesTitleTwo}}</h4>
              <p *ngIf="rulesDescriptionTwo" [innerText]="rulesDescriptionTwo"></p>
              <div class="bottomText">
                <p>Any change in cutoff date/number of entries per category or any changes are totally up to {{
                  academyName }} team's
                  discretion.</p>
                <p>For further inquiries and registration, please contact {{academyName}} via the TPL app or
                  {{academyName}} WhatsApp group.
                  Don't miss the chance to showcase your skills and compete in the {{academyName}} {{tournamentname}}!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 mainNotesDiv">
        <div class="notes">
          <div class="icon">
            <img src="../../../../assets/images/factsheet/information-circle.svg" alt="">
          </div>
          <div class="notesText">
            Please note that the TPL App is not
            responsible for the tournament's management
            or draw process. These responsibilities
            solely rest with the host academy. If you
            have any concerns, disputes, or queries,
            kindly contact the host academy directly.
          </div>
        </div>
      </div>

      <div class="tplStructure">
        <h3 class="factSheettitle">Tpl Ranking Structure</h3>
        <div class="tableDiv">
          <table>
            <thead>
              <tr>
                <th>tournament</th>
                <th> <span class="pointtitle">
                    <div class="minTable-w"> TPL 1000 <br>points</div>
                  </span></th>
                <th><span class="pointtitle">
                    <div class="minTable-w">TPL 500 <br>points</div>
                  </span></th>
                <th><span class="pointtitle">
                    <div class="minTable-w">TPL 250 <br>points</div>
                  </span></th>
                <th><span class="pointtitle">
                    <div class="minTable-w">TPL 25 <br>points</div>
                  </span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div>Winner</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 1000') ? 'selected' : ''">
                  <div class="minTable-w">1000</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 500') ? 'selected' : ''">
                  <div class="minTable-w">500</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 250') ? 'selected' : ''">
                  <div class="minTable-w">250</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 25') ? 'selected' : ''">
                  <div class="minTable-w">25</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Runner up</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 1000') ? 'selected' : ''">
                  <div class="minTable-w">600</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 500') ? 'selected' : ''">
                  <div class="minTable-w">300</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 250') ? 'selected' : ''">
                  <div class="minTable-w">150</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 25') ? 'selected' : ''">
                  <div class="minTable-w">15</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Semifinalists</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 1000') ? 'selected' : ''">
                  <div class="minTable-w">360</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 500') ? 'selected' : ''">
                  <div class="minTable-w">180</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 250') ? 'selected' : ''">
                  <div class="minTable-w">90</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 25') ? 'selected' : ''">
                  <div class="minTable-w">9</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Quarter Finalists</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 1000') ? 'selected' : ''">
                  <div class="minTable-w">180</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 500') ? 'selected' : ''">
                  <div class="minTable-w">90</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 250') ? 'selected' : ''">
                  <div class="minTable-w">45</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 25') ? 'selected' : ''">
                  <div class="minTable-w">5</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Round 16</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 1000') ? 'selected' : ''">
                  <div class="minTable-w">90</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 500') ? 'selected' : ''">
                  <div class="minTable-w">45</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 250') ? 'selected' : ''">
                  <div class="minTable-w">20</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 25') ? 'selected' : ''">
                  <div class="minTable-w">0</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Round 32</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 1000') ? 'selected' : ''">
                  <div class="minTable-w">45</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 500') ? 'selected' : ''">
                  <div class="minTable-w">20</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 250') ? 'selected' : ''">
                  <div class="minTable-w">15</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 25') ? 'selected' : ''">
                  <div class="minTable-w">0</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Round 64</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 1000') ? 'selected' : ''">
                  <div class="minTable-w">25</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 500') ? 'selected' : ''">
                  <div class="minTable-w">10</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 250') ? 'selected' : ''">
                  <div class="minTable-w">7</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 25') ? 'selected' : ''">
                  <div class="minTable-w">0</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Round 128</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 1000') ? 'selected' : ''">
                  <div class="minTable-w">10</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 500') ? 'selected' : ''">
                  <div class="minTable-w">5</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 250') ? 'selected' : ''">
                  <div class="minTable-w">3</div>
                </td>
                <td [ngClass]="(item?.pointsDataName[0] === 'TPL 25') ? 'selected' : ''">
                  <div class="minTable-w">0</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</section>


<!-- Add buttons for other platforms -->

<!-- <section *ngIf="userAccess && showPage" class="body-section" style="padding-top: 30px;">
  <div class="container">
    <main> 
      <section class="team Tournaments-list">

        <div class="container aos-init aos-animate" data-aos="fade-up">
          <div class="row">

            <div class="col-md-12 find-partner-page Factsheet-body  p-p-0">
              <div class="col-md-12 p-p-0">
                <div class="right-side-section col-md-12">


                  <div class="wrapper max-w-3xl mx-auto px-0">
                    <div class="item my-3 p-4 border">
                      <div class="row">
                        <div class="col-md-12 body-header">
                          <div class="media w-100 justify-content-space-between mb-3"> 
                            <div class="media-body">
                              <h4 class="text-left">{{tournamentname}}</h4>

                              <div class="sub-headings">
                                <i class='bx bx-map'></i> {{cityname}} |
                                Surface: {{courttype}}
                              </div>
                            </div>

                            <div class="media-right d-flex align-items-center main-action">
                              <div class="share-buttons  mr-2 " [ngClass]="{'show-button-share': isShareButtonClicked}">

                                <div class="share-buttons-btn desktop-version">
                                  <a href="{{shareurl}}" target="_blank">
                                    <button class="share-button-click">
                                      <i class='bx bxl-whatsapp'></i> Share</button>
                                  </a>
                                </div> 
                              </div>
                               
                              <div class="enter-button d-flex align-items-center main-actions-buttons" style="gap:0px;">

                                <div class="media-right mr-3 palyer-count">

                                  <button (click)="onClicktournamentPlayerList()"><span class="flagiconm"><i
                                        class='bx bxs-flag-checkered'></i></span>
                                    <span class="big">{{totalPlayercount}}</span>
                                    registered players
                                  </button>
                                </div>
                                <div class="media-right mr-3 action-list-btn">
                                  <div class="btn-list">  
                                    <li class="btn-list" *ngIf="showRegisterButton">

                                      <button *ngIf="tournamentIds.includes(tournamentId)" id="edit-login"
                                        (click)="withdrawtournament(tournamentId,lastdateofwithdraw)">
                                        <span>
                                          <i class='bx bx-edit-alt'></i>
                                        </span> Edit Registration </button>
                                      <button [disabled]="outdate_reg_status"
                                        *ngIf="!tournamentIds.includes(tournamentId)" id="edit-login"
                                        (click)="showloginDialog(tournamentId)">
                                        <span>
                                          <i class='bx bx-plus'></i>
                                        </span>Register </button>
                                    </li>
                                    <li class="btn-list" *ngIf="!showRegisterButton">
                                      <button id="edit-login" *ngIf="viewPlayerList"
                                        (click)="onClicktournamentPlayerList()"
                                        style="background-color: black; color: #fff!important;"><span
                                          style="    display: flex; align-items: center;justify-content: center;"><i
                                            class="bx bxs-user-detail" style="color: #fff!important;"></i>
                                        </span>
                                        Entries List<span class="mobile-d-none"
                                          style="color: #fff; font-weight: 400;"></span>
                                      </button>
                                    </li>
                                  </div> 
                                </div>  
                              </div>

                            </div>

                          </div>
                          <hr>
                        </div> 

                        <div class="Tournament-details-bodty">
                          <div class=" col-md-8 col-sm-12 p-0">
                            <table class="clear condensed secondLeft d-inline-block"> 

                              <tr class="row-club-organizer">
                                <th class="px-2 text-right">
                                  Organizer
                                </th>
                                <td class="px-2">

                                  <a (click)="onclickAcademydetails()" class="" style="cursor: pointer;">
                                    {{academyName}}
                                  </a>
                                </td>
                              </tr>
                              <tr class="mobile-w-100">
                                <th class="text-right px-2">
                                  Location
                                </th>
                                <td class="px-2">{{address}}, {{cityname}},
                                  {{statename}} {{zipcode}},
                                  {{countryname}}</td>
                                <th class="text-right mobile-d-none"></th>
                                <td class=" mobile-d-none"></td>
                              </tr>
                              <tr>
                                <th class="text-right px-2">
                                  Last Date Of Registration</th>
                                <td class="px-2">{{ lastdateofregistration |
                                  date:'dd/MM/yyyy' }}
                                </td>
                                <th class="text-right mobile-d-none"></th>
                                <td class=" mobile-d-none"></td>
                              </tr>
                              <tr>
                                <th class="text-right px-2"> Tournament Start Date
                                </th>
                                <td class="px-2">{{ startdate | date:'dd/MM/yyyy' }}
                                </td>
                                <th class="text-right mobile-d-none"></th>
                                <td class=" mobile-d-none"></td>
                              </tr>
                              <tr>
                                <th class="text-right px-2"> Tournament End Date
                                </th>
                                <td class="px-2">{{ enddate | date:'dd/MM/yyyy' }}
                                </td>
                                <th class="text-right mobile-d-none"></th>
                                <td class=" mobile-d-none"></td>
                              </tr>
                              <tr>
                                <th class="text-right px-2"> Last Date Of Withdrawal
                                </th>
                                <td class="px-2">{{ lastdateofwithdraw |
                                  date:'dd/MM/yyyy' }}
                                </td>
                                <th class="text-right mobile-d-none"></th>
                                <td class=" mobile-d-none"></td>
                              </tr>

                              <tr>
                                <th class="text-right px-2">Organizer Contact Number
                                </th>
                                <td class="px-2">
                                  <a class="link-main" href="tel:{{ organizercontactnumber}}" target="_blank"
                                    rel="noopener noreferrer"><i class="bx bx-phone-call"></i>
                                    {{ organizercontactnumber}}</a>

                                </td>
                                <th class="text-right mobile-d-none"></th>
                                <td class=" mobile-d-none"></td>
                              </tr>
                              <tr class="wrap-table whatsapp-link-td">
                                <th class="text-right px-2">Tournament WhatsApp Group
                                  Link
                                </th>
                                <td class="px-2">


                                  <a *ngIf="whatsAppgrouplink!=''" href="{{ whatsAppgrouplink}}" target="_blank"
                                    class="link-main"><i class="bx bxl-whatsapp"></i>
                                    <span>{{ whatsAppgrouplink}}</span> </a>
                                </td>
                                <th class="text-right mobile-d-none"></th>
                                <td class=" mobile-d-none"></td>
                              </tr>
                            </table>
                          </div>
                          <div class="col-md-4 right-side-logos-div">
                            <div class="side-bar-div">
                              <div class="tournament-logo ">
                                <img [src]="(academyPic) ? academyPic : '../../../../assets/images/academy_dummy.jpg'"
                                  alt="">
                              </div>

                              <div class="col-md-12 admin-details">
                                <a (click)="oncickdetails(academyId)">
                                  <h4 class="p-mb-0" style="margin-top: 0.5rem;">
                                    {{academyName}}</h4>
                                </a>

                              </div>
                            </div>
                          </div>

                        </div>
                        <div class="Tournament-details-bottom">
                          <h6 class="Categories-table-heading">Categories</h6>
                          <table class="table Categories-table-ui">
                            <thead>
                              <tr>

                                <th scope="col"> Match Type</th>
                                <th scope="col"> Age Group</th>
                                <th scope="col"> Entry Fee <em>Per Player</em>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="row_1" *ngFor="let fees of tournamentCategories">

                                <td>{{fees.matchtypeData[0].name}}</td>
                                <td>{{fees.ageGroupData[0].name}}</td>
                                <td>₹ {{fees.entryFee}}</td>
                              </tr>


                            </tbody>
                          </table>
                          <hr>
                          <h6>Tournament Rules & Regulations</h6>
                          <div class="col-md-12 p-p-0">
                            <table class="tounament-rules">
                              <tbody>

                                <tr class="factsheet-tr">
                                  <th class="text-right px-2">
                                    Factsheet</th>
                                  <td class="px-2">

                                    <div class="Factsheet">
                                      <div class="">
                                        <p><b>*Tournament Format*</b> </p>
                                        <p [innerText]="regulations"></p>
                                        <div></div>

                                      </div>
                                    </div>

                                  </td>
                                  <th class="text-right mobile-d-none"></th>
                                  <td class="mobile-d-none"></td>
                                </tr>
                                <tr>
                                  <td colspan="3">

                                    <div class="tpl-notes">
                                      Please note that the TPL App is not
                                      responsible for the tournament's management
                                      or draw process. These responsibilities
                                      solely rest with the host academy. If you
                                      have any concerns, disputes, or queries,
                                      kindly contact the host academy directly.
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                        </div>
                        <div class="Tournament-details-bottom Ranking-Structure-table">
                          <h6 class="Categories-table-heading">TPL Ranking Structure</h6>
                          <div class="table-div-section">
                            <table>
                              <thead>
                                <tr>
                                  <th>Tournament</th>
                                  <th>Winner</th>
                                  <th>Runner Up</th>
                                  <th>2 Semi<br class="mobile-br"> Finalists</th>
                                  <th>4 Quarter<br class="mobile-br"> Finalists</th>
                                  <th>Round of<br class="mobile-br"> 16 </th>
                                  <th>Round of<br class="mobile-br"> 32 </th>
                                  <th>Round of<br class="mobile-br"> 64 </th>
                                  <th>Round of<br class="mobile-br"> 128 </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="row_1">
                                  <td>TPL 1000 Points</td>
                                  <td>1000</td>
                                  <td>600</td>
                                  <td>360</td>
                                  <td>180</td>
                                  <td>90</td>
                                  <td>45</td>
                                  <td>25</td>
                                  <td>10</td>
                                </tr>
                                <tr class="row_1">
                                  <td>TPL 500 Points</td>
                                  <td>500</td>
                                  <td>300</td>
                                  <td>180</td>
                                  <td>90</td>
                                  <td>45</td>
                                  <td>20</td>
                                  <td>10</td>
                                  <td>5</td>
                                </tr>
                                <tr class="row_1">
                                  <td>TPL 250 Points</td>
                                  <td>250</td>
                                  <td>150</td>
                                  <td>90</td>
                                  <td>45</td>
                                  <td>20</td>
                                  <td>15</td>
                                  <td>7</td>
                                  <td>3</td>
                                </tr>
                                <tr class="row_1">
                                  <td>TPL 25 Points</td>
                                  <td>25</td>
                                  <td>15</td>
                                  <td>9</td>
                                  <td>5</td>
                                  <td>0</td>
                                  <td>0</td>
                                  <td>0</td>
                                  <td>0</td>
                                </tr>

                              </tbody>
                            </table>
                          </div>

                        </div> 
                        <div class="Tournament-details-bottom">
                          <h6>Sponsors</h6>
                        </div>
                        <div class="grid-sponser" style="width: 1326px; transform: translate3d(0px, 0px, 0px);">
                          <div class="list" role="group" *ngFor="let sponsorLogo of sponsor_logo"><img
                              src="{{sponsorLogo.img_src}}" class="img-fluid" alt="">
                          </div> 
                        </div>  
                      </div>
                    </div>  
                  </div>
                  <div class="pagination flex justify-center my-5"></div>
                </div>
              </div> 
            </div> 
          </div>
        </div>
        <div class="share-buttons-btn mobile-version">
          <a href="{{shareurl}}" target="_blank">
            <button class="share-button-click"><i class='bx bxl-whatsapp'></i>
              Share</button>
          </a>

        </div>
      </section> 
    </main>
  </div>
</section> -->


<p-dialog id="Entertournament" [(visible)]="TournamentEntry"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }"
  [modal]="TournamentEntry" [draggable]="false" [resizable]="false" (onHide)="catageclose()">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">TOURNAMENT REGISTRATION</h5>
    <!-- <div class="headings col-md-12">
      <h6>{{tournamentname}}</h6>
    </div> -->
  </ng-template>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
        max-width: 100%;">
    <div class="modal-content">
      <div class="modal-body">
        <div class="add-even col-md-12">
          <div class="list-tournamnet-add">
            <form [formGroup]="myForm">
              <div formArrayName="fields" class="w-100 add-categorey-section">
                <div class=" selectcategory-div" *ngFor="let fieldGroup of fieldsFormArray.controls; let i = index"
                  [formGroupName]="i">
                  <!-- <div class="col-md-12 list">
                    <label for="matchtype">Tournament Category</label>
                    <p-dropdown inputId="matchtype{{i}}" [options]="tourcatList" formControlName="matchTypeId"
                      appendTo="body" optionLabel="matchTypeName" optionValue="matchTypeId"
                      (onChange)="onMatchSelect($event,i)"></p-dropdown>
                  </div>
                  <div class="col-md-12 list mixed-hide">
                    <label for="agegroup">Age Category</label>
                    <p-dropdown inputId="agegroup{{i}}" emptyMessage="No eligible age group or entries might be full"
                      emptyFilterMessage="No eligible age group or entries might be full" [options]="subAgegroup[i]"
                      formControlName="ageGroupId" appendTo="body" optionLabel="label" optionValue="value"
                      (onChange)="onAgeGroupSelect($event, i)"></p-dropdown>
                  </div> -->
            <ng-container *ngIf="hasAnyTournamentCategory; else noCategories">
            
              <p-dropdown inputId="categories{{i}}" [options]="getSelectableCategoriesForField(i)" formControlName="categories"
                [disabled]="disableCategories[i]"
                emptyFilterMessage="No eligible tournament category and age group or entries might be full" appendTo="body"
                optionLabel="categoryName" (onChange)="onTournamentCategorySelect($event, i)">
              </p-dropdown>
            </ng-container>
            <ng-template #noCategories>
              <div class="no-category-message">
                <span>ⓘ</span>
                <span>No categories available for your age group</span>
              </div>
            </ng-template>
                  <div class="category-full-message" *ngIf="getFullCategoryNamesForField(i)">
                    {{ getFullCategoryNamesForField(i) }} - Category is Full
                  </div>
                  <!-- <div class="col-md-12 list">
                    <label for="categories">Categories</label>
                    <p-dropdown inputId="categories{{i}}" [options]="categoryAndAgeGroupList"
                      formControlName="categories" [disabled]="disableCategories[i]"
                      emptyFilterMessage="No eligible tournament category and age group or entries might be full"
                      appendTo="body" optionLabel="categoryName"
                      (onChange)="onTournamentCategorySelect($event, i)"></p-dropdown>
                  </div> -->
                  <div class="addPartner" id="add_double_partner_{{i}}" style="display: none;">
                    <button class="add-partner" (click)="showaddPartnerDialog(i)">ADD PARTNER</button>
                  </div>
                  <!-- <div class="col-md-12 list" *ngIf="showPmdtaNumber">
                    <label for="matchtype">PMDTA Number</label>
                    <input formControlName="pmdtaNumber" (input)="onPmdtaNumberInput($event,i)" type="text" pInputText class="form-control" 
                    [ngClass]="{ 'ng-dirty': (g(i).pmdtaNumber.errors) || (g(i).pmdtaNumber.touched || g(i).pmdtaNumber.invalid) }"
                    placeholder="Enter Number"> 
                <div *ngIf="(g(i).pmdtaNumber.errors) || (g(i).pmdtaNumber.touched || g(i).pmdtaNumber.invalid)">
                    <div class="invalid-text" *ngIf="g(i).pmdtaNumber.errors?.required">PMDTA Number is required.</div>
                    <div class="invalid-text" *ngIf="!g(i).pmdtaNumber.errors?.required && g(i).pmdtaNumber.errors">Please enter a valid PMDTA Number.</div>
                </div>
                  </div> -->
                  <div id="double_partner_{{i}}" style="display: none;">
                    <h6 style="margin-top: 10px;" class="title-lable">Doubles Partner</h6>
                    <div class="form">
                      <div class="input-group mb-3">
                        <input type="hidden" formControlName="doublePlayerId" inputId="doublePlayerId{{i}}"
                          name="searchemailuserid" class="form-control" id="exampleFormControlInput1">
                        <input type="text" formControlName="doubleUserEmail" class="form-control doubleInputForm"
                          placeholder="-" aria-label="Recipient's username" aria-describedby="changePlayer" disabled>
                        <span class="input-group-text" (click)="showaddPartnerDialog(i)" id="changePlayer">
                          CHANGE PARTNER
                        </span>

                      </div>
                      <!-- <div class="col-md-12 list" *ngIf="showDoublePmdtaNumber">
                        <label for="matchtype">Partner PMDTA Number</label>
                        <input formControlName="doublePlayerPmdtaNumber" (input)="onPmdtaNumberInput($event, i)" type="text" pInputText class="form-control" 
                            [ngClass]="{ 'ng-dirty': (partneremailemail !== null) && ((g(i).doublePlayerPmdtaNumber.errors) || (g(i).doublePlayerPmdtaNumber.touched || g(i).doublePlayerPmdtaNumber.invalid)) }"
                            placeholder="Enter Number">
                        <div *ngIf="(partneremailemail !== null) && ((g(i).doublePlayerPmdtaNumber.errors) || (g(i).doublePlayerPmdtaNumber.touched || g(i).doublePlayerPmdtaNumber.invalid))">
                            <div class="invalid-text" *ngIf="g(i).doublePlayerPmdtaNumber.errors?.required">PMDTA Number is required.</div>
                            <div class="invalid-text" *ngIf="!g(i).doublePlayerPmdtaNumber.errors?.required && g(i).doublePlayerPmdtaNumber.errors">Please enter a valid PMDTA Number.</div>
                        </div>
                      
                    </div> -->
                    </div>
                    <div class="notes">
                      <div class="icon">
                        <img src="../../../assets/images/tournament/information-circle.svg" alt="">
                      </div>
                      <p>Ensure the partner is registered on the app at least 30 minutes before the tournament starts.
                      </p>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <!-- Display the price for each selected age group -->
                    <input type="hidden" [formControlName]="getPriceFormControlName(i)" [value]="selectedEntryFees[i]">
                  </div>
                  <div class="col-md-12 remove-category" *ngIf="i>0">
                    <button *ngIf="i>0" type="button" (click)="removeField(i)">Remove
                      Category</button>
                  </div>
                </div>
              </div>
              <div class="category-full-message" *ngIf="registrationCategoryErrorMessage">
                {{ registrationCategoryErrorMessage }}
              </div>
              <div class="add-more-btn">
                <button type="button" (click)="addField()" [disabled]="!isTournamentCatgeorySelected || !hasAddableCategories">
                  <i class="bx bx-plus" style="color: #000;"></i>Add Another Event</button>
              </div>


              <div class="col-md-12 d-none" *ngIf="totalEntryFee() !== 0">
                <h6 class="JuniorBoysSingles">Enter Fees : {{ totalEntryFee() }} TPL Cash</h6>
              </div>
            </form>

            <div class="form-check p-0 d-flex align-items-center mb-2 mt-2"
              [ngClass]="showTermsAndConditionError ? 'Error-div' : ''">
              <p-checkbox binary="true" [value]="termsAndConditions" (onChange)="onTermsAndConditionsSelect($event)"
                [(ngModel)]="termsAndConditions" inputId="termsAndConditions"></p-checkbox>
              <label class="form-check-label termsandconditiontext" for="defaultCheck1">
                I accept the <a class="termsConditionText" href="/termsandcondition#TPLtournament">terms and
                  conditions</a>
              </label>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <!-- <button [ngClass]="termsAndConditions ? 'enable-btn' : 'disable-btn'" type="button"
        class="btn btn-primary mx-auto" (click)="walletPay()" [disabled]="!myForm.valid">Confirm</button> -->
      <button [ngClass]="termsAndConditions && myForm.valid && !hasFullSelectedCategory ? 'enable-btn' : 'disable-btn'" type="button"
        class="btn btn-primary mx-auto" (click)="walletPay()" [disabled]="!termsAndConditions || !myForm.valid || hasFullSelectedCategory">CONFIRM
        REGISTRATION</button>
    </div>
    <div class="footerApp">
      <div class="footerhead">
        <div class="logo">
          <img src="../../../assets/images/tournament/logo.png" alt="">
        </div>
        <div class="desciption">
          <h4>TPL App</h4>
          <p>Other account tournament registration only on app</p>
        </div>
      </div>
      <div class="footerDivider">
        <img src="../../../assets/images/tournament/hr.png" alt="">
      </div>
      <div class="footerfoot">
        <h6>DOWNLOAD NOW</h6>
        <ul>
          <li>
            <button>
              <img src="../../../assets/images/tournament/playstore.png" alt="">
            </button>
          </li>
          <li>
            <button>
              <img src="../../../assets/images/tournament/appsotre.png" alt="">
            </button>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog id="Entertournamentpartner" [(visible)]="addPartner"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="addPartner"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">TOURNAMENT REGISTRATION</h5>
    <!-- <div class="headings col-md-12">
      <h6>{{tournamentname}}</h6>
    </div> -->
  </ng-template>
  <!---test-->
  <form [formGroup]="emailForm" class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    style="margin: 0px!important;    width: 100%;  max-width: 100%;">
    <div class="modal-content">
      <!-- <div class="modal-header">
        <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry </h5>
        <div class="headings col-md-12">
          <h6>{{tournamentname}}</h6>
          <p class="note"> You can find a new doubles partner by entering their Mobile Number. </p>
        </div>
       
      </div> -->
      <div class="modal-body">
        <div class="add-even col-md-12">
          <div class="col-md-12 list">
            <h6>PARTNER’S MOBILE NUMBER</h6>
            <div class="mobile0numberField">
              <div class="countryCode">
                <p-dropdown inputId="phoneCode" formControlName="phoneCode" appendTo="body" [options]="countryCodeList"
                  optionLabel="phone_code" (onChange)="setCountryCode($event)" [filter]="true"
                  [ngClass]="{ 'ng-dirty ng-invalid': submitted && this.emailForm.get('phoneCode').errors }">
                  <ng-template pTemplate="selectedItem" let-selectedOption>
                    <div class="flex justify-content-center align-items-center gap-2">
                      <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                        [class]="'flag flag-' + selectedOption.code.toLowerCase()" style="width: 18px" />
                      <div>{{ selectedOption.phone_code }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-country pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                        [class]="'flag flag-' + country.code.toLowerCase()" style="width: 18px" />&nbsp;&nbsp;
                      <span>{{ country?.phone_code }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <p-inputNumber [useGrouping]="false" id="inputtext-left" formControlName="mobileNumber" [maxlength]="10"
                type="number" maxlength="10" class="form-control" id="exampleFormControlInput1"
                placeholder="Mobile Number" mode="decimal" (change)="clearEmailErrors()" required>
              </p-inputNumber>
            </div>
                   <div *ngIf="emailForm.get('mobileNumber').hasError('required') && emailForm.get('mobileNumber').touched"
              class="text-danger errorText">Mobile Number required</div>
            <div
              *ngIf="emailForm.get('mobileNumber').hasError('maxlength') && !emailForm.get('mobileNumber').hasError('required') && emailForm.get('mobileNumber').touched"
              class="text-danger errorText">Enter a valid Mobile Number</div>
            <div
              *ngIf="!emailForm.get('mobileNumber').hasError('maxlength') && !emailForm.get('mobileNumber').hasError('required')  && !duplicateEmailError && emailerrormsg"
              class="text-danger errorText">Mobile Number not Found</div>
            <div *ngIf="duplicateEmailError && !emailerrormsg" class="text-danger errorText">You can't use your own register
              Mobile Number</div>
            <div class="notes">
              <div class="icon">
                <img src="../../../assets/images/tournament/information-circle.svg" alt="">
              </div>
              <p>Enter mobile no. of a player that is registered to TPL.</p>
            </div>
            <!-- <h6>Enter Email Address of Player that is registered with the TPL</h6> -->

            <!-- <div class="mb-3">
               
              <p-inputNumber mode="decimal" class="partnerMobile w-100" [useGrouping]="false" formControlName="emailForm.get('mobileNumber')" [maxlength]="10" required placeholder="Enter Partner Mobile Number" (change)="clearEmailErrors()">
                </p-inputNumber>
            </div> -->

            <!-- <div
              *ngIf="emailForm.get('mobileNumber').hasError('email') && !emailForm.get('mobileNumber').hasError('required') && emailForm.get('mobileNumber').touched"
              class="text-danger">Enter a valid Email Id</div>
            <div
              *ngIf="!emailForm.get('mobileNumber').hasError('email') && !emailForm.get('mobileNumber').hasError('required')  && !duplicateEmailError && emailerrormsg"
              class="text-danger">Email Id not Found</div>
            <div *ngIf="duplicateEmailError && !emailerrormsg" class="text-danger">You can't use your own register Email
              id</div> -->
     
          </div>

        </div>

      </div>
      <div class="modal-footer">
        <div class="form-check p-0 d-flex align-items-center mb-2 mt-2"
          [ngClass]="showTermsAndConditionError ? 'Error-div' : ''">
          <p-checkbox binary="true" [value]="termsAndConditions"
            (onChange)="onAddPartnerTermsAndConditionsSelect($event)" [(ngModel)]="addPartnerTermsAndConditions"
            [ngModelOptions]="{standalone: true}" inputId="termsAndConditions"></p-checkbox>
          <label class="form-check-label termsandconditiontext" for="defaultCheck1">
            I accept the <a class="termsConditionText" href="/termsandcondition#TPLtournament">terms and
              conditions</a>
          </label>
        </div>
        <!-- <button type="button" class="btn btn-primary mx-auto " (click)="addedPartner()">Add Partner</button> -->
        <button [ngClass]="addPartnerTermsAndConditions && emailForm.valid ? 'enable-btn' : 'disable-btn'" type="button"
          class="btn btn-primary mx-auto" (click)="addedPartner()"
          [disabled]="!addPartnerTermsAndConditions || !emailForm.valid">Add Partner</button>
      </div>
    </div>
  </form>
  <!-- <ng-template pTemplate="footer"><p-button icon="pi pi-check" (click)="visible = false" label="Ok" styleClass="p-button-text"></p-button></ng-template> -->
</p-dialog>


<p-dialog id="completeProfile" [(visible)]="welcomeLogin"
  [breakpoints]="{ '960px': '500px', '768px': 'calc(100% - 60px)', '389px': 'calc(100% - 30px)' }"
  [style]="{ width: '500px' }" [modal]="true" [draggable]="false" [resizable]="false"
  (onHide)="hideWelcomeLoginDialog()">
  <div class="Welcome-popup">
    <h4>
      Complete Your Profile!
    </h4>
    <p>You are required to complete your profile to proceed further</p>
    <hr class="line-div">
    <div class="actionButton">
      <div class="completeProfile_Button">
        <button type="button" [routerLink]="(!isContestVerified) ? '/profile-edit2' : '/dob-verification'"
          [queryParams]="(!isContestVerified) ? { page : 'tournaments/factsheet/'+id} : { isAbout18: isAbove18Check, page : 'tournaments/factsheet/'+id}">Complete
          Profile</button>
      </div>
      <div class="skip_Button">
        <button (click)="hideWelcomeLoginDialog()">Cancel</button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog id="Pay" [(visible)]="Walletdialog" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
  [style]="{ width: '400px' }" [modal]="Walletdialog" [draggable]="false" [resizable]="false" (onHide)="onHideWalletDialog()">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">TOURNAMENT REGISTRATION</h5>
    <!-- <div class="headings col-md-12">
      <h6>{{tournamentname}}</h6>
    </div> -->
  </ng-template>

  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
        max-width: 100%;">
    <div class="modal-content">
      <div class="paymentPayBody">
        <div class="summery" *ngIf="Walletdialog">
          <h6>SUMMARY</h6>
          <div *ngIf="selectedTournamentCategory && selectedAgeGroup && selectedEntryFees"
            class="table-selectform w-100">
            <table class="table  ">
              <!-- <thead>
                <tr>
                  <th scope="col">Categories</th>
                  <th scope="col">Age</th>
                  <th scope="col">Entry Fees</th>
                </tr>
              </thead> -->
              <tbody>
                <!-- Loop through selected tournament categories and age groups -->
                <tr *ngFor="let category of selectedTournamentCategory; index as i;">
                  <td>{{ category.matchname }} - {{ category.agegroupname }}</td>
                  <td class="rightTd">₹{{ selectedEntryFees[i] }}</td>
                </tr>
                <!-- <tr *ngIf="fees?.platformFeeStatus">
                  <td>Platform Fee</td>
                  <td class="rightTd">{{ (fees?.platformFeeType === 'flat') ? '₹' : ''}} {{ fees?.platformFee }} {{ (fees?.platformFeeType === 'percentage') ? '%' : ''}}</td>
                </tr> -->
                <tr *ngIf="fees?.platformFeeStatus">
                  <td>
                    Platform Fee
                      <span *ngIf="fees?.platformFeeType === 'percentage'">
                        ({{ fees?.platformFee }}%)
                       </span>
                      </td>
                       <td class="rightTd">  ₹{{ getPlatformFeeAmount() | number:'1.2-2' }}
                         </td>
                         </tr>
                     <!-- <tr *ngIf="fees?.convenienceFeeStatus">
                    <td>Convenience Fee</td>
                    <td class="rightTd">{{ (fees?.convenienceFeeType === 'flat') ? '₹' : ''}} {{ fees?.convenienceFee }} {{ (fees?.convenienceFeeType === 'percentage') ? '%' : ''}}</td>
                  </tr> -->
                       <tr *ngIf="fees?.convenienceFeeStatus">
                        <td>
                            Convenience Fee
                             <span *ngIf="fees?.convenienceFeeType === 'percentage'">
                               ({{ fees?.convenienceFee }}%)
                              </span>
                              </td>
                               <td class="rightTd">
                      ₹{{ getConvenienceFeeAmount() | number:'1.2-2' }}
                       </td>
                      </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <strong>TOTAL AMOUNT</strong>
                  </td>
                  <td class="rightTd">
                    <strong>₹{{ totalEntryFee() }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div class="paymentFoot">
        <form action="#">
          <div class="col-md-12 add-buttons">
            <ul>
              <li class="tpl-cash d-flex">
                <label class="form-check-label" for="flexRadioDefault1">
                  <input class="form-check-input" type="checkbox" name="flexRadioDefault" id="flexRadioDefault1" [(ngModel)]="isRadioButtonClicked"
                    (click)="onRadioClick()" checked>
                  <span class="icon"> <img src="../../../assets/images/tournament/wallet.svg" alt=""> </span> TPL Wallet
                  Balance
                </label>
                <div class="buttons d-flex ">
                  <span class="Balance mr-2"> ₹{{walletBalance | number:'1.2-2'}}</span>
                  <!-- <span class="addmore" (click)="Addcashdialog()"> Load Wallet </span> -->

                </div>
              </li>
            </ul>
            <div class="thamkyou-notes" *ngIf="thankYouMsg">
              <p-messages severity="success">
                <ng-template pTemplate>
                  <img src="../../../assets/img/Tournament/checked.png" width="32" />
                  <div class="note-div-section w-100 ml-2">
                    <div class="ml-1 w-100">Thank You!</div>
                    <div class="note">
                      Your wallet has been successfully credited with the amount.
                    </div>
                  </div>
                </ng-template>
              </p-messages>
            </div>
            <p class="cash-ms" [ngClass]="{ 'disabled-message': !isRegisterButtonEnabled()}">
              <span *ngIf="displayCashMs">After Transaction Your Balance Will Be ₹{{
                totalleftCash}}</span>
            </p>
            <p class="add-money-message" *ngIf="showAddMoneyMessage">Please add money to your wallet</p>
            <!-- <div class="col-md-12 text-center"> -->
            <!--a id="Entered-btn" class="button button-primary" (click)="thankyouModal(); isRegisterButtonEnabled()" [ngClass]="{ 'disabled-button': !isRegisterButtonEnabled() }"> Register </a-->
            <!-- <a id="Entered-btn" class="button button-primary" (click)="thankyouModal()"
                                [ngClass]="{ 'disabled-button': !isRegisterButtonEnabled() }"> Register </a> -->
            <!-- </div> -->
          </div>

          <div class="registration-expired-message" *ngIf="isRegistrationExpired">
            <div class="expired-icon">
              <i class="pi pi-exclamation-circle"></i>
            </div>
          
            <div class="expired-content">
              <strong>Registration deadline is over</strong>
            </div>
          </div>
    

          <div class="totalPaybal">
            <div class="title">
              TOTAL AMOUNT PAYABLE
            </div>
            <div class="amount">₹{{ totalEntryFee() }}</div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="form-check p-0 d-flex align-items-center mb-2 mt-2"
      [ngClass]="showTermsAndConditionError ? 'Error-div' : ''">
      <p-checkbox binary="true" [value]="walletDialogTermsAndConditions"
        (onChange)="onWalletDialogTermsAndConditionsSelect($event)" [(ngModel)]="walletDialogTermsAndConditions"
        [ngModelOptions]="{standalone: true}" inputId="termsAndConditions"></p-checkbox>
      <label class="form-check-label termsandconditiontext" for="defaultCheck1">
        I accept the <a class="termsConditionText" href="/termsandcondition#TPLtournament">terms and
          conditions</a>
      </label>
    </div>
    <!-- <a id="Entered-btn" class="button button-primary" (click)="thankyouModal()"
        [ngClass]="{ 'disabled-button': !isRegisterButtonEnabled() }"> Register </a> -->
    <!-- <a id="Entered-btn" [ngClass]="termsAndConditions ? 'enable-btn' : 'disable-btn'" class="button button-primary" 
    (click)="thankyouModal()"> Pay ₹{{ totalEntryFee() }} </a> -->
    <button [ngClass]="walletDialogTermsAndConditions && !isRegistrationExpired ? 'enable-btn': 'disable-btn'" type="button"
      class="btn btn-primary mx-auto" (click)="thankyouModal()" [disabled]="!walletDialogTermsAndConditions">Pay ₹{{
      totalEntryFee() }}</button>
  </div>

</p-dialog>
<p-dialog id="add-cash" [(visible)]="Addcashmodal" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
  [style]="{ width: '500px' }" [modal]="true" [draggable]="false" [resizable]="false" (onHide)="cashclose()">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-header card-title">
        <h1 class="modal-title fs-5" id="add-cashLabel">Add Cash</h1>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body add-cash pay">
        <div class="card-body">
          <div class="payment-info flex justify-space-between">
            <div class="column shipping w-100">
              <form [formGroup]="addCashForm" *ngIf="this.addCashForm">
                <div class="container-fluid grid">
                  <div class="row pull-center">
                    <div class="col-md-12 mobile-p-none ">
                      <div class="wallet-screen" style="display: block;">
                        <div class="total-amount">
                          <div class="wallet-icons">
                            <div class="icon">
                              <i class='bx bx-wallet-alt'></i>
                            </div>
                            <h1>Enter Amount</h1>
                          </div>
                          <div class="col-md-12 add-buttons">
                            <div class="add-money-form col-md-12">
                              <input type="number" id="myInput2" placeholder="₹ 0" formControlName="amount" readonly
                                [(ngModel)]="addedAmount" [ngClass]="{ 'is-invalid': submitted && a.amount.errors }">
                              <div *ngIf="submitted && a.amount.errors" class="invalid-feedback">
                                <div *ngIf="a.amount.errors.required">Amount is required</div>
                                <div *ngIf="a.amount.errors">Only Numbers allowed</div>
                              </div>
                              <div class="p-field p-col-12 msg-div">
                                <p-messages severity="info">
                                  <ng-template pTemplate>
                                    <i class="pi pi-info-circle"></i>
                                    <div class="ml-2">Please Note: For iPhone users - To make a payment using Gpay,
                                      select "Others" option in the UPI menu and manually enter your UPI ID.</div>
                                  </ng-template>
                                </p-messages>

                              </div>
                            </div>

                            <div id="text-out">{{outputText}}</div>
                            <div class="col-md-12 text-center">
                              <a href="#" (click)="onCashSubmit($event)" class="button button-primary"> Add to Wallet
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog id="Entertournamentthank" [(visible)]="thanYoumodal"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry </h5>
    <!-- <div class="headings col-md-12">
      <h6>{{tournamentname}}</h6>
    </div> -->
  </ng-template>
  <!---test-->
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="headings col-md-12">
          <h6>{{tournamentname}}</h6>
          <p class="note" *ngIf="!(this.walletdata?.tournamentPlayerCategoryArr.length === this.walletdata?.refundedCategories.length)">You have successfully registered</p>
          <p class="text-danger" *ngIf="refundTournamentCategoriesMessage">Note: {{ refundTournamentCategoriesMessage }}</p>
        </div>
        <div class="countdown-container">
          <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
          <div class="countdown-text">{{ countdown }}</div>
          <br>

        </div>
        <div class="timer-alert">
          Please wait 10 seconds.
        </div>
        <p class="note text-left mainNotes">
          <span> <img src="../../../assets/images/tournament/information-orange.svg" alt=""> </span>
          <span>Your payment will be automatically debited from Wallet.</span>

        </p>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog id="Entertournamentview" [(visible)]="WithdrawModal"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false" (onHide)="Withdrawclose()">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry </h5>
    <!-- <div class="headings col-md-12">
      <h6>{{tournamentname}}</h6>
    </div> -->
  </ng-template>
  <!---test-->
  <!---test-->
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="headings col-md-12">
          <h6>{{tournamentname}}</h6>
          <p class="note">
            Please select a category from the below list to withdraw.
          </p>
        </div>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="add-even col-md-12">
          <!-- <div class="event-number">Add Partner</div> -->
          <div class="event-details-list" *ngFor="let registeredtournamentdatalist of registeredtournamentdata">
            <div class="list-div-selection" [ngClass]="{'selected': wid === registeredtournamentdatalist.id}">
              <div class="event-details">
                <!-- <div class="title">{{registeredtournamentdatalist.tournamentName}}</div> -->
                <div class="Event-cate">
                  <ul>
                    <li>
                      <span class="small-heading">{{registeredtournamentdatalist.matchTypeName}}</span>
                      <p>{{registeredtournamentdatalist.ageGroupName}}</p>
                    </li>
                  </ul>
                </div>
                <div class="checkbox-icon">
                  <label for="{{registeredtournamentdatalist.id}}">


                    <input type="radio" id="{{registeredtournamentdatalist.id}}" name="fav_language"
                      (click)="withdraw_select(registeredtournamentdatalist.id,registeredtournamentdatalist.tournamentName,registeredtournamentdatalist.matchTypeName,registeredtournamentdatalist.ageGroupName)">

                    <span>Withdraw</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="add-more-btn col-md-12"><button type="button" [disabled]="outdate_reg_status" (click)="registeredAddField();"> Add Another Event
              <i class="bx bx-plus" style="color: #fff;"></i></button></div> 
        </div>


      </div>
      <div *ngIf="withdraw_confirm_status==true" style="text-align: center;">
        <b style="color: red;">Withdraw date over</b>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" [disabled]="withdraw_confirm_status" class="btn btn-primary mx-auto "
          (click)="Withdrawconfirmmodal()">Confirm</button> -->
        <button type="button" [disabled]="withdrawButtonClicked || withdraw_confirm_status"
          class="btn btn-primary mx-auto" (click)="Withdrawconfirmmodal()">Confirm</button>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog id="widthdraw-confitmation" [(visible)]="WithdrawcnfModal"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">Withdraw Confirmation </h5>
    <!-- <div class="headings col-md-12">
      <h6>{{tournamentname}}</h6>
    </div> -->
  </ng-template>

  <!---test-->
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-body">
        <p>Are you sure you want to withdraw from the tournament category? Please note that this action can not be
          undone, and
          your participation in the tournament will be cancelled. </p>
        <div class="add-even col-md-12">
          <div class="event-details-list">
            <div class="list-div-selection">
              <div class="event-details">
                <div class="title">{{tname}}</div>
                <div class="Event-cate">
                  <ul>
                    <li>
                      <span class="small-heading">{{mtn}}</span>
                      <p>{{agn}}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <p>After the withdrawal, the entry fee amount will be credited back to your TPL wallet.
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary mx-auto " (click)="thankyouwithdraw()">Proceed with the
          withdrawal</button>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog id="Entertournamentthank" [(visible)]="thankwithdraw"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry </h5>
    <!-- <div class="headings col-md-12">
      <h6>{{tournamentname}}</h6>
    </div> -->
  </ng-template>

  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="headings col-md-12">

          <h6>{{tournamentname}}</h6>


          <div class="countdown-container">
            <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
            <div class="countdown-text">{{ countdown }}</div>
            <br>

          </div>
          <div class="timer-alert">
            Please wait
          </div>
          <p class="note">We are processing your refund request in the tournament category. Once the refund is processed
            successfully, please check Wallet Balance.</p>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [closable]="true" [(visible)]="showForgotPasswordForm" [modal]="true" [style]="{width: '500px'}"
  id="forgot-password" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false">
  <section *ngIf="showForgotPasswordForm" class="login-page-section">
    <div class="section-title text-center">
      <p> Forgot Password
      </p>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 ">
          <div class="col-md-12 login-page">
            <form [formGroup]="forgotPassForm">
              <div class="row">
                <div class="col-lg-12">
                  <div class="style-form-group">
                    <input type="email" formControlName="email" class="form-control form-input"
                      placeholder="Your Email *"
                      [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                    <div *ngIf="submitted && forgotPassValidation.email.errors" class="invalid-feedback">
                      <div *ngIf="forgotPassValidation.email.errors.required">Email is
                        required</div>
                      <div *ngIf="forgotPassValidation.email.errors.pattern">Email must be a
                        valid
                        email address</div>
                    </div>
                    <div *ngIf="successMessage" style="color:green;">{{successMessage.message}}
                    </div>
                    <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}</div>
                  </div>
                </div>
              </div>
              <div class="button pt-2 pt-lg-3">
                <button class="forgot-pass-submit" (click)="onForgotPassSubmit()">Submit</button>&nbsp;&nbsp;
                <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</p-dialog>

<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
  id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false" [closable]="false"  [position]="position" >
  <div class="downloadbody">
    <div class="topleftbg">
      <img src="../../../../assets/images/download/topleft.png" alt="">
    </div>
    <div class="bottomrightbg">
      <img src="../../../../assets/images/download/bottomright.png" alt="">
    </div>
    <div class="bottomleftbg">
      <img src="../../../../assets/images/download/bottomleft.png" alt="">
    </div>
    <div class="download-header">
      <button (click)="downloadModal = false" class="closeBtn">
        <img src="assets/images/download/close.svg" alt="">
      </button>
    </div>
    <div class="bannerImage">
      <img src="../../../../assets/images/download/leander.png" alt="">
    </div>
    <div class="modalTitleImage">
      <img src="../../../../assets/images/download/modalTile.svg" alt="">
    </div>

    <div class="downloadList">
      <ul>
        <li>
          <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
            <img src="../../../../assets/images/download/btn1.png" alt="">
          </a>
        </li>
        <li>
          <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
            <img src="../../../../assets/images/download/btn2.png" alt="">
          </a>
        </li>
      </ul>
    </div>

    <div class="orTitle">
      <div class="line"></div>
      <p>OR</p>
      <div class="line"></div>
    </div>
    <div class="scanner">
      <img src="../../../../assets/images/download/qrcode.png" alt="">
    </div>
    <div class="notesdiv">
      <p>Click the buttons above to download the <span>App!</span></p>
    </div>
  </div>
</p-dialog>
